import { useOnboarding } from '@/hooks/useOnboarding';
import { WelcomeStep } from './steps/WelcomeStep';
import { WorkshopDataStep } from './steps/WorkshopDataStep';
import { InviteTeamStep } from './steps/InviteTeamStep';
import { PricingStep } from './steps/PricingStep';
import { CompletionStep } from './steps/CompletionStep';

export function OnboardingWizard() {
  const {
    currentStep,
    totalSteps,
    profile,
    nextStep,
    previousStep,
    skipStep,
    completeOnboarding,
  } = useOnboarding();

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-background">
      {/* Progress bar */}
      <div className="shrink-0 border-b border-border px-6 py-3">
        <div className="flex items-center justify-between">
          <span className="text-xs font-medium text-muted-foreground">
            Etapa {currentStep + 1} de {totalSteps}
          </span>
          {currentStep > 0 && currentStep < totalSteps - 1 && (
            <button
              onClick={skipStep}
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Pular
            </button>
          )}
        </div>
        <div className="mt-2 h-1.5 w-full rounded-full bg-muted">
          <div
            className="h-full rounded-full bg-primary transition-all duration-300"
            style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
          />
        </div>
      </div>

      {/* Step content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {currentStep === 0 && <WelcomeStep onNext={nextStep} />}
        {currentStep === 1 && (
          <WorkshopDataStep onNext={nextStep} onBack={previousStep} />
        )}
        {currentStep === 2 && (
          <InviteTeamStep
            onNext={nextStep}
            onBack={previousStep}
            onSkip={skipStep}
          />
        )}
        {currentStep === 3 && (
          <PricingStep
            onNext={nextStep}
            onBack={previousStep}
            onSkip={skipStep}
          />
        )}
        {currentStep === 4 && (
          <CompletionStep
            profile={profile}
            onComplete={completeOnboarding}
          />
        )}
      </div>
    </div>
  );
}
